import "./fd-pkgs/fd-url-manager/javascripts/Fandango.link.js";
import "./fd-pkgs/@fd-assets/micromodal/javascripts/microModal.js";